import { render } from "./HelpStates-edit.vue?vue&type=template&id=3a74813f"
import script from "./HelpStates-edit.vue?vue&type=script&lang=js"
export * from "./HelpStates-edit.vue?vue&type=script&lang=js"

import "./HelpStates-edit.vue?vue&type=style&index=0&id=3a74813f&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__